import { productPageActionPrefix } from 'views/ProductPage/actions';
import { Action } from 'redux';

export const SELECT_CONFIGURATOR_INSTALLATION = `${productPageActionPrefix}SELECT_CONFIGURATOR_INSTALLATION`;
export const SELECT_CONFIGURATOR_ADDON = `${productPageActionPrefix}SELECT_CONFIGURATOR_ADDON`;
export const RESET_INSTALLATION_ADDONS_ACTION = `${productPageActionPrefix}RESET_POLARPUMP_ACTION`;
export const RESET_INSTALLATION_ACTION = `${productPageActionPrefix}RESET_INSTALLATION_ACTION`;
export const RESET_INSTALLATION_CONFIGURATOR = `${productPageActionPrefix}RESET_INSTALLATION_CONFIGURATOR`;

export interface SelectInstallationProductAction extends Action {
  productId: string;
}

export const selectConfiguratorInstallation = (
  productId: string
): SelectInstallationProductAction => ({
  type: SELECT_CONFIGURATOR_INSTALLATION,
  productId
});

export const selectConfiguratorAddon = (productId: string): SelectInstallationProductAction => ({
  type: SELECT_CONFIGURATOR_ADDON,
  productId
});

export const resetConfiguratorAddons = (): Action => ({
  type: RESET_INSTALLATION_ADDONS_ACTION
});

export const resetInstallationConfigurator = (): Action => ({
  type: RESET_INSTALLATION_CONFIGURATOR
});

export const resetInstallation = (): Action => ({
  type: RESET_INSTALLATION_ACTION
});
